export function formatNumber(value: number): string {
  return value.toLocaleString("en-GB");
}
